import ModalBase from '@/app/customComponents/modals/ModalBase';
import React from 'react';
import { CalendarEventCard } from './CalendarEventCard';

const CalendarEventModal = ({ open, setOpen, event, setRefresh, refresh }) => {
	const handleClose = () => {
		setOpen(false);
	};
	return (
		<ModalBase maxWidth={600} open={open} setOpen={setOpen} showClose={false}>
			<CalendarEventCard event={event} handleClose={handleClose} refresh={refresh} setRefresh={setRefresh} />
		</ModalBase>
	);
};

export default CalendarEventModal;
